var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopys = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1104 2.39844H11.372C9.67832 2.39842 8.3368 2.39841 7.2869 2.54013C6.2064 2.68599 5.33185 2.9933 4.64216 3.68576C3.95246 4.37822 3.64639 5.25628 3.50112 6.34113C3.35996 7.39524 3.35997 8.74213 3.35999 10.4426V16.0466C3.35999 17.4944 4.24314 18.7351 5.49807 19.2553C5.43348 18.3822 5.43353 17.1572 5.43358 16.138L5.43359 11.4201L5.43358 11.3288C5.43351 10.0984 5.43345 9.03822 5.54714 8.18926C5.66897 7.27944 5.94372 6.40732 6.64827 5.69993C7.35283 4.99254 8.22146 4.7167 9.12765 4.59437C9.97321 4.48023 11.0291 4.48029 12.2546 4.48036L12.3456 4.48037H15.1104L15.2014 4.48036C16.4269 4.48029 17.4805 4.48023 18.326 4.59437C17.8202 3.30831 16.5711 2.39844 15.1104 2.39844Z",
    fill: "#F6932B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81599 11.4201C6.81599 8.80298 6.81599 7.4944 7.62578 6.68136C8.43557 5.86832 9.73891 5.86832 12.3456 5.86832H15.1104C17.7171 5.86832 19.0204 5.86832 19.8302 6.68136C20.64 7.4944 20.64 8.80298 20.64 11.4201V16.0466C20.64 18.6638 20.64 19.9724 19.8302 20.7854C19.0204 21.5984 17.7171 21.5984 15.1104 21.5984H12.3456C9.73891 21.5984 8.43557 21.5984 7.62578 20.7854C6.81599 19.9724 6.81599 18.6638 6.81599 16.0466V11.4201Z",
    fill: "#F6932B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopys, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Copys.4a6fdae8.svg";
export { ForwardRef as ReactComponent };